<div class="dialogContainer">
  <div class="content">
    <div class="tableContainer">
      @if (!selectedAddress()) {
        <org-address-grid (addressSelected)="selectAddress($event)"
        [addresses]="addressList()"></org-address-grid>
      }
      <div class="centered">
        @if (selectedAddress()) {
          <org-address-detail [isEdit]="false" [address]="selectedAddress()"></org-address-detail>
        }
      </div>
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    @if (!readOnly && isNew) {
      <span>
        <input id="persistInput" type="checkbox" [(ngModel)]="addAddress"/>
        <label for="persistInput">Add To Address Book</label>
      </span>
    }
    <span class="spacer"></span>
    <span>
      @if (!readOnly && entity().updateAllowed && !selectedAddress()) {
        <button matButton="elevated"
        (click)="newAddress()">New</button>
      }
      @if (!readOnly && entity().updateAllowed && selectedAddress()) {
        <button matButton="elevated"
        (click)="clearSelectedAddress()">Change</button>
      }
      <button matButton="elevated" (click)="cancel()">Close</button>
      @if (!readOnly && entity().updateAllowed && selectedAddress()) {
        <button matButton="elevated" (click)="saveAndClose()">Select</button>
      }
    </span>
  </div>
</div>


